import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50.412",
  height: "45.57",
  viewBox: "0 0 50.412 45.57"
}
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'base-svg',
  props: {
    controlColor: { default: '#fff' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      id: "liuchengguanli",
      d: "M104.782,112a3.536,3.536,0,0,1,3.535,3.536v11.785a3.535,3.535,0,0,1-3.535,3.536H97.974v2.226h9.64a5.491,5.491,0,0,1,5.482,5.409v4.019h4.779a3.536,3.536,0,0,1,3.535,3.536v7.988a3.535,3.535,0,0,1-3.535,3.536H104.913a3.536,3.536,0,0,1-3.535-3.536v-7.988a3.535,3.535,0,0,1,3.535-3.536h4.779v-3.928a2.087,2.087,0,0,0-2.037-2.095H84.8a2.087,2.087,0,0,0-2.078,2.053v3.97H87.5a3.536,3.536,0,0,1,3.535,3.536v7.988A3.535,3.535,0,0,1,87.5,157.57H74.535A3.535,3.535,0,0,1,71,154.034v-7.988a3.535,3.535,0,0,1,3.535-3.536h4.779v-3.928a5.492,5.492,0,0,1,5.392-5.5h9.862v-2.226H86.713a3.535,3.535,0,0,1-3.535-3.536V115.536A3.536,3.536,0,0,1,86.713,112h18.07Z",
      transform: "translate(-71 -112)",
      fill: _ctx.controlColor
    }, null, 8, _hoisted_2)
  ]))
}
}

})